// PlanModal.jsx — "Mi plan": ver el plan actual y cancelar la renovación del Pro.
import { useState } from "react";

const btnBase = { border:'none', borderRadius:8, padding:'10px 20px', fontSize:13.5, fontWeight:700, cursor:'pointer', fontFamily:'inherit' };

export default function PlanModal({ user, isPaid, onClose }) {
  const [fase, setFase] = useState('info'); // info | confirmar | cargando | listo | error
  const [msg, setMsg]   = useState('');

  const cancelar = async () => {
    setFase('cargando');
    try {
      const r = await fetch('/api/mp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'cancel', userId: user.id }),
      });
      const d = await r.json();
      if (d.ok) {
        const f = d.hasta
          ? new Date(d.hasta).toLocaleDateString('es-CO', { day:'numeric', month:'long', year:'numeric' })
          : null;
        setMsg(f
          ? `Listo. No se volverá a cobrar. Tu acceso Pro sigue activo hasta el ${f}.`
          : 'Listo. No se volverá a cobrar.');
        setFase('listo');
      } else {
        setMsg(d.error || 'No se pudo cancelar. Escríbenos a hola@kin-map.com y lo resolvemos.');
        setFase('error');
      }
    } catch {
      setMsg('Error de conexión. Intenta de nuevo o escríbenos a hola@kin-map.com.');
      setFase('error');
    }
  };

  return (
    <div onClick={fase !== 'cargando' ? onClose : undefined} style={{ position:'fixed', inset:0, background:'rgba(2,8,18,.82)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div onClick={e => e.stopPropagation()} style={{ background:'#0B1526', border:'1px solid rgba(255,255,255,.1)', borderRadius:16, maxWidth:440, width:'100%', padding:'26px 28px' }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:14 }}>
          <div style={{ fontSize:18, fontWeight:800, color:'#fff' }}>Mi plan</div>
          {fase !== 'cargando' && (
            <button onClick={onClose} aria-label="Cerrar" style={{ background:'none', border:'none', color:'#64748B', fontSize:20, cursor:'pointer', padding:4, lineHeight:1, fontFamily:'inherit' }}>✕</button>
          )}
        </div>

        <div style={{ fontSize:13, color:'#64748B', marginBottom:18 }}>{user?.email}</div>

        {!isPaid && (
          <>
            <div style={{ fontSize:14.5, color:'rgba(255,255,255,.85)', marginBottom:18 }}>
              Tienes el <strong>Plan Gratis</strong>. Con el Plan Pro obtienes acceso completo: todas las filas, filtros, rankings, exportar CSV y análisis con IA.
            </div>
            <a href="#pricing" onClick={onClose} style={{ ...btnBase, display:'inline-block', textDecoration:'none', background:'#0EA5A4', color:'#fff' }}>Ver Plan Pro →</a>
          </>
        )}

        {isPaid && fase === 'info' && (
          <>
            <div style={{ fontSize:14.5, color:'rgba(255,255,255,.85)', marginBottom:6 }}>
              Tienes el <strong style={{ color:'#0EA5A4' }}>Plan Pro</strong> con renovación automática.
            </div>
            <div style={{ fontSize:12.5, color:'#64748B', marginBottom:20 }}>
              Si cancelas la renovación, no se vuelve a cobrar y conservas el acceso Pro hasta el final del período ya pagado.
            </div>
            <div style={{ display:'flex', gap:10 }}>
              <button onClick={onClose} style={{ ...btnBase, background:'rgba(255,255,255,.1)', color:'#fff' }}>Cerrar</button>
              <button onClick={() => setFase('confirmar')} style={{ ...btnBase, background:'transparent', border:'1px solid rgba(255,255,255,.2)', color:'#94A3B8' }}>Cancelar renovación</button>
            </div>
          </>
        )}

        {isPaid && fase === 'confirmar' && (
          <>
            <div style={{ fontSize:14.5, color:'rgba(255,255,255,.85)', marginBottom:20 }}>
              ¿Seguro que quieres cancelar la renovación? No se volverá a cobrar y tu acceso Pro seguirá activo hasta el final del período pagado.
            </div>
            <div style={{ display:'flex', gap:10 }}>
              <button onClick={() => setFase('info')} style={{ ...btnBase, background:'#0EA5A4', color:'#fff' }}>No, mantener mi plan</button>
              <button onClick={cancelar} style={{ ...btnBase, background:'transparent', border:'1px solid #E0A339', color:'#E0A339' }}>Sí, cancelar</button>
            </div>
          </>
        )}

        {fase === 'cargando' && (
          <div style={{ fontSize:14, color:'#64748B', padding:'10px 0' }}>Cancelando con MercadoPago…</div>
        )}

        {(fase === 'listo' || fase === 'error') && (
          <>
            <div style={{ fontSize:14.5, color: fase === 'listo' ? 'rgba(255,255,255,.85)' : '#E0A339', marginBottom:20 }}>{msg}</div>
            <button onClick={onClose} style={{ ...btnBase, background:'rgba(255,255,255,.1)', color:'#fff' }}>Cerrar</button>
          </>
        )}
      </div>
    </div>
  );
}
